// extracted by mini-css-extract-plugin
export var container = "_86-0";
export var error = "_86-9";
export var label = "_86-5";
export var light = "_86-6";
export var md = "_86-3";
export var sm = "_86-2";
export var thin = "_86-8";
export var thinBold = "_86-7";
export var vertical = "_86-4";
export var xs = "_86-1";